import {
  IStationAssignmentCreate,
  IStationCreate,
} from '@tsin-core/models/station-management.model';

const ACTION_SCOPE = '[Stations]';

export class CreateStation {
  static readonly type = `${ACTION_SCOPE} Create Station`;
  constructor(public payload: IStationCreate) {}
}

export class CreateStationAssignment {
  static readonly type = `${ACTION_SCOPE} Create Station Assignment`;
  constructor(public payload: IStationAssignmentCreate) {}
}

export class GetStations {
  static readonly type = `${ACTION_SCOPE} Get Stations`;
}

export class UpdateStation {
  static readonly type = `${ACTION_SCOPE} Update Stations`;
  constructor(public editPayload: any) {}
}

export class DeleteStation {
  static readonly type = `${ACTION_SCOPE} Delete Station`;
  constructor(public id: string) {}
}

export class SetLoading {
  static readonly type = `${ACTION_SCOPE} Set Loading`;
  constructor(public loading: boolean) {}
}

export class SetError {
  static readonly type = `${ACTION_SCOPE} Set Error`;
  constructor(public error: string | null) {}
}
